import { StyledEngineProvider, ThemeProvider, adaptV4Theme, createTheme } from '@mui/material/styles'
import { iframeResizerContentWindow } from 'iframe-resizer'
import { SnackbarProvider } from 'notistack'
import React from 'react'
import ReactDOM from 'react-dom'
import { Redirect, Route, BrowserRouter as Router, Switch } from "react-router-dom"
import 'typeface-roboto'
import AppContextProvider from './context/AppContextProvider'
import wylieTheme from './themes/default.js'
import NotFound from './views/404'
import BookAnyStore from './views/BookAnyStore'
import GuestLoginRedirect from './views/GuestLoginRedirect'
import PrintQRCode from './views/PrintQRCode'
import StoreList from './views/StoreList'
import StoresWithService from './views/StoresWithService'

// this needs to be referenced so it isn't tree-shaken.
iframeResizerContentWindow // tslint:disable-line no-unused-expression

let isEmbedded = false

try {
    isEmbedded = window.self != window.top
} catch (e) {
    isEmbedded = true
}

// set height to 100% unless embedded within an iframe
if (!isEmbedded) {
    document.querySelectorAll('html, body').forEach(el => el.style.height = '100%')
}

const defaultTheme = createTheme(adaptV4Theme(wylieTheme))

ReactDOM.render(
    <StyledEngineProvider injectFirst>
        <ThemeProvider theme={defaultTheme}>
            <SnackbarProvider>
                <Router>
                    <Switch>
                        {/* SPECIAL ROUTES */}


                        {/* DEPRECATED: Book service as guest */}
                        <Route path="/:fileset/s:storeId/bookAsGuest/:bookUrl*" render={({ match }) => (
                            <Redirect to={`/${match.params.fileset}/s${match.params.storeId}/guest/book/${match.params.bookUrl || ''}`} />
                        )} />

                        {/* DEPRECATED: Order as guest */}
                        <Route path="/:fileset/s:storeId/orderAsGuest/:orderUrl*" render={({ match }) => (
                            <Redirect to={`/${match.params.fileset}/s${match.params.storeId}/guest/order/${match.params.orderUrl || ''}`} />
                        )} />

                        {/* 30-10 SPECIAL: Book any store providing a service */}
                        <Route path="/:fileset/bookAnyStore/:serviceName*">
                            <BookAnyStore />
                        </Route>

                        {/* Book desired service at stores that offer it - using service abbreviation */}
                        <Route path="/:fileset/findStoresWithServiceAbbrev/:serviceAbbrev*">
                            <StoresWithService />
                        </Route>

                        {/* Auto login as guest and redirect back to desired url */}
                        <Route path="/:fileset/s:storeId/guest/:url*">
                            <GuestLoginRedirect />
                        </Route>

                        {/* QR Code Print */}
                        <Route path="/qrcode">
                            <PrintQRCode />
                        </Route>


                        {/* REGULAR ROUTES */}


                        {/* App */}
                        <Route path="/:fileset/s:storeId">
                            <AppContextProvider isEmbedded={isEmbedded} />
                        </Route>

                        {/* Store list */}
                        <Route path="/:fileset">
                            <StoreList />
                        </Route>

                        {/* Root */}
                        <Route>
                            <NotFound />
                        </Route>
                    </Switch>
                </Router>
            </SnackbarProvider>
        </ThemeProvider>
    </StyledEngineProvider>,
    document.getElementById('root')
)
